import { useQuery } from '@tanstack/react-query'
import { fetchDocumentRelationRoles, IDocumentRelationRoleOption } from '../constants'
import { useBusinessContext } from '@root/context'

export const useDocumentRelationRoles = () => {
  const { slug } = useBusinessContext()

  return useQuery<IDocumentRelationRoleOption[]>({
    queryKey: [slug, 'document_relation_roles'],
    queryFn: () => fetchDocumentRelationRoles({ slug }),
    staleTime: 1000 * 60 * 60,
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!slug
  })
}
